import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

function Hero() {
  return (
    <section className="hero">
      <div className="hero-inner">
        <h1 className="hero-title">Smart Deals Everyday</h1>
        <p className="hero-subtitle">
          Hand-picked daily deals to save you money on the things you actually use.
        </p>
        <div className="hero-buttons">
          <a className="hero-btn hero-btn-main" href="#deals">Today's Deals</a>
          <Link className="hero-btn" to="/category/Freebies">Freebies</Link>
          <Link className="hero-btn" to="/blog">Blog</Link>
        </div>
      </div>
    </section>
  );
}

export default Hero;
